import SalesMonthlyReportPage from './SalesMonthlyReportPage';

export default SalesMonthlyReportPage;
